import {
  MAX_L_ADDRESS,
  MAX_L_BIZ_REG_NO,
  MAX_L_MOBILE,
  MAX_L_PERSON_NAME,
  MAX_L_POSTCODE,
  MAX_L_VEHICLE_NO,
  REGEX_SN_ADDRESS,
  REGEX_SN_ALPHANUMERIC,
  REGEX_SN_BIZ_REG_NO,
  REGEX_SN_EMAIL,
  REGEX_SN_MOBILE_NO,
  REGEX_SN_PERSON_NAME,
  sanitizeByRegex,
} from "@digital/utils";

export const normalizeRegNo = (e) => {
  const { value } = e.target;
  e.target.value = sanitizeByRegex(value, REGEX_SN_ALPHANUMERIC, {
    trim: true,
    maxLength: MAX_L_VEHICLE_NO,
    forceCase: "upper",
  });
};

export const normalizeName = (e) => {
  const { value } = e.target;
  e.target.value = sanitizeByRegex(value, REGEX_SN_PERSON_NAME, {
    trim: false,
    maxLength: MAX_L_PERSON_NAME,
    forceCase: "upper",
  });
};

export const normalizeNRIC = (e) => {
  let value = e.target.value;
  value = value
    .split("-")
    .join("")
    .replace(/[!-,.-/:-~]|\s/g, "");
  if (value.length > 0) {
    value = value.match(new RegExp(".{1,6}", "g")).join("-");
    value = value.match(new RegExp(".{1,9}", "g")).join("-");
  }
  e.target.value = value;
};

export const normalizeNumber = (e) => {
  const { value } = e.target;
  e.target.value = value.replace(/[!-/:-~]|\s/g, "").replace(/^0/, "");
};

export const normalizePostcode = (e) => {
  const { value } = e.target;
  e.target.value = sanitizeByRegex(value, REGEX_SN_MOBILE_NO, {
    trim: true,
    maxLength: MAX_L_POSTCODE,
  });
};

export const normalizeSSTNumber = (e) => {
  let value = e.target.value.toUpperCase();

  value = value.replace(/[^A-Z0-9]/gi, "");

  if (value.length > 0) {
    const firstChar = value[0].replace(/[^A-Z]/g, "");

    const rest = value.slice(1).replace(/[^0-9]/g, "");

    value = firstChar + rest;
  }

  if (value.length > 3) {
    value = value.slice(0, 3) + "-" + value.slice(3);
  }

  if (value.length > 8) {
    value = value.slice(0, 8) + "-" + value.slice(8);
  }

  value = value.slice(0, 17);

  e.target.value = value;
};

export const normalizePhone = (e) => {
  const { value } = e.target;
  e.target.value = sanitizeByRegex(value, REGEX_SN_MOBILE_NO, {
    trim: true,
    maxLength: MAX_L_MOBILE,
  });
};

export const normalizeAddress = (e) => {
  const { value } = e.target;
  e.target.value = sanitizeByRegex(value, REGEX_SN_ADDRESS, {
    trim: false,
    maxLength: MAX_L_ADDRESS,
    forceCase: "upper",
  });
};

export const normalizeBizRegNo = (e) => {
  const { value } = e.target;
  e.target.value = sanitizeByRegex(value, REGEX_SN_BIZ_REG_NO, {
    trim: true,
    maxLength: MAX_L_BIZ_REG_NO,
    forceCase: "upper",
  });
};

export const normalizeEmail = (e) => {
  const { value } = e.target;
  e.target.value = sanitizeByRegex(value, REGEX_SN_EMAIL, {
    trim: true,
    forceCase: "lower",
  });
};

export default {
  normalizeName,
  normalizeNRIC,
  normalizeNumber,
  normalizeRegNo,
  normalizePhone,
  normalizeAddress,
  normalizeBizRegNo,
  normalizePostcode,
  normalizeEmail,
};
